import { RouterModule } from '@angular/router';
import { MigrationSniperWrapperComponent } from './components/migration-sniper-wrapper/migration-sniper-wrapper.component';
import { NgModule } from '@angular/core';
import { MigrationSniperListComponent } from './components/migration-sniper-list/migration-sniper-list.component';

const routes = [
    {
        path: '',
        component: MigrationSniperWrapperComponent,
        children: [
            {
                path: '',
                component: MigrationSniperListComponent,
            },
            {
                path: 'add',
                loadChildren: () =>
                    import('./modules/migration-sniper-wizard/migration-sniper-wizard.module').then(
                        (m) => m.MigrationSniperWizardModule,
                    ),
            },
            {
                path: 'edit/:id',
                loadChildren: () =>
                    import('./modules/migration-sniper-wizard/migration-sniper-wizard.module').then(
                        (m) => m.MigrationSniperWizardModule,
                    ),
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MigrationSniperRoutingModule {}
